import styled from 'styled-components'
import { Container, Grid, Typography } from '@material-ui/core'
import { Icon } from '../icon/icon'
import { rem } from '../../utils'

export const StyledIconGroup = styled(Grid)`
  background: ${props => props.theme.custom.colors.lightSecondary};
  padding-top: ${props => props.theme.typography.pxToRem(58)};
  padding-bottom: ${props => props.theme.typography.pxToRem(58)};
  padding-left: ${props => props.theme.typography.pxToRem(74)};
  padding-right: ${props => props.theme.typography.pxToRem(74)};
  flex-direction: column-reverse;

  ${props => props.theme.breakpoints.up('md')} {
      justify-content: flex-end;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    min-width: ${props => props.theme.typography.pxToRem(426)};
    margin-right: ${props => props.theme.typography.pxToRem(-160)};
  }
`

export const StyledTitleText = styled(Typography)`
  color: ${props => props.theme.palette.text.primary};
  font-size: ${props => props.theme.typography.pxToRem(18)};
  font-weight: 500;
  line-height: 1.3;
  transition: margin-right 0.2s ease, color 0.2s ease;
`

export const StyledTitleCheveron = styled(Icon)`
  position: absolute;
  right: -15px;
  top: 16px;
  margin-top: ${props => props.theme.typography.pxToRem(4)};
  color: ${props => props.theme.palette.primary.main};
  font-size: ${props => props.theme.typography.pxToRem(12)};
  transition: margin-right 0.2s ease;
`

export const StyledCardContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  column-gap: ${props => props.theme.typography.pxToRem(25)};
  margin-bottom: ${props => props.theme.typography.pxToRem(14)};
  text-align: right;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.20);

  &:last-of-type {
    margin-bottom: 0;
  }

  > div:first-child {
    padding: ${props => props.theme.typography.pxToRem(6)} 0;
  }

  &:hover {
    ${StyledTitleCheveron} {
      margin-right: -${props => props.theme.typography.pxToRem(10)};
    }

    ${StyledTitleText} {
      color: ${props => props.theme.palette.secondary.dark};
    }
  }

  & > a {
    display: flex;
    flex-direction: row;
    text-decoration: none;
    justify-content: space-between;
    width: 100%;

    & > div > p {
      margin-left: ${props => props.theme.typography.pxToRem(0)};
    }
  }
`

export const StyledTitleTextContainer = styled(Grid)`
  position: relative;
  width: 100%;
  overflow-wrap: break-word;
  cursor: pointer;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  gap: ${props => props.theme.typography.pxToRem(5)};
  text-align: left;

  > a {
    text-decoration: none;
    overflow-wrap: normal;
  }
`

export const StyledOverviewTitle = styled.span`
  color: ${props => props.theme.palette.secondary.dark};
  font-size: ${props => props.theme.typography.pxToRem(18)};
  font-weight: ${props => props.theme.typography.fontWeightBold};
  transition: color 0.3s ease;
  text-decoration: none;
  margin-bottom: 20px;
`

export const StyledOverviewChevron = styled.div<{ $desktop?: boolean }>`
  position: ${props => props.$desktop ? 'unset' : 'absolute'};
  right: ${props => props.$desktop ? 'unset' : '20px'};
  margin-left: ${props => props.$desktop ? '10px' : 'unset'};
  width: ${props => rem(35, props.theme)};
  height: ${props => rem(35, props.theme)};

  svg {
    fill: ${props => props.theme.palette.secondary.dark};
  }
`

export const StyledOverviewContainer = styled.div`
  display: inline-block;
  margin-top: ${props => rem(0, props.theme)};

  a {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${props => props.theme.palette.text.primary};
    transition: color 0.2s ease;
    white-space: nowrap;
  }

  &:hover {
    ${StyledOverviewTitle} {
      color: ${props => props.theme.palette.secondary.dark};
    }

    a {
      color: ${props => props.theme.palette.primary.main};
    }
  }
`

export const StyledHeaderContainer = styled(Container)`
  max-width: ${props => rem(1920, props.theme)};
  margin: auto;
  background-color: ${props => props.theme.palette.background.default};
  padding-left: 0;
  padding-right: 0;
  height: ${props => rem(56, props.theme)};

  > header {
    max-width: ${props => rem(1920, props.theme)};
    right: unset;
  }

  ${props => props.theme.breakpoints.up('xl')} {
    > header {
      max-width: 100%;
      right: 0;
    }
  }

  ${props => props.theme.breakpoints.up('sm')} {
    height: 56px;     
  }  

  ${props => props.theme.breakpoints.up('md')} {
    height: ${props => rem(80, props.theme)};
  }
`


